@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-1_789_565_004)
internal val Res.string.compras_import_action: StringResource by lazy {
      StringResource("string:compras_import_action", "compras_import_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18373, 41),
      ))
    }

@delegate:ResourceContentHash(1_291_267_458)
internal val Res.string.compras_import_category_label: StringResource by lazy {
      StringResource("string:compras_import_category_label", "compras_import_category_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18415, 65),
      ))
    }

@delegate:ResourceContentHash(-1_918_548_077)
internal val Res.string.compras_import_error: StringResource by lazy {
      StringResource("string:compras_import_error", "compras_import_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18481, 84),
      ))
    }

@delegate:ResourceContentHash(-1_724_103_689)
internal val Res.string.compras_import_format: StringResource by lazy {
      StringResource("string:compras_import_format", "compras_import_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18566, 57),
      ))
    }

@delegate:ResourceContentHash(1_545_856_532)
internal val Res.string.compras_import_invalid_file: StringResource by lazy {
      StringResource("string:compras_import_invalid_file", "compras_import_invalid_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18624, 71),
      ))
    }

@delegate:ResourceContentHash(-1_073_349_624)
internal val Res.string.compras_import_items: StringResource by lazy {
      StringResource("string:compras_import_items", "compras_import_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18696, 64),
      ))
    }

@delegate:ResourceContentHash(-589_616_049)
internal val Res.string.compras_import_period: StringResource by lazy {
      StringResource("string:compras_import_period", "compras_import_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18761, 49),
      ))
    }

@delegate:ResourceContentHash(-1_157_844_136)
internal val Res.string.compras_import_processing: StringResource by lazy {
      StringResource("string:compras_import_processing", "compras_import_processing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18811, 65),
      ))
    }

@delegate:ResourceContentHash(167_424_579)
internal val Res.string.compras_import_ready: StringResource by lazy {
      StringResource("string:compras_import_ready", "compras_import_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18877, 60),
      ))
    }

@delegate:ResourceContentHash(-73_361_778)
internal val Res.string.compras_import_remove_file: StringResource by lazy {
      StringResource("string:compras_import_remove_file", "compras_import_remove_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18938, 54),
      ))
    }

@delegate:ResourceContentHash(-1_194_293_327)
internal val Res.string.compras_import_select_file: StringResource by lazy {
      StringResource("string:compras_import_select_file", "compras_import_select_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18993, 58),
      ))
    }

@delegate:ResourceContentHash(-680_217_022)
internal val Res.string.compras_import_sheet: StringResource by lazy {
      StringResource("string:compras_import_sheet", "compras_import_sheet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19052, 52),
      ))
    }

@delegate:ResourceContentHash(-1_457_631_592)
internal val Res.string.compras_import_step_category: StringResource by lazy {
      StringResource("string:compras_import_step_category", "compras_import_step_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19105, 64),
      ))
    }

@delegate:ResourceContentHash(-27_800_434)
internal val Res.string.compras_import_step_upload: StringResource by lazy {
      StringResource("string:compras_import_step_upload", "compras_import_step_upload", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19170, 70),
      ))
    }

@delegate:ResourceContentHash(-914_518_314)
internal val Res.string.compras_import_success: StringResource by lazy {
      StringResource("string:compras_import_success", "compras_import_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19241, 74),
      ))
    }

@delegate:ResourceContentHash(-2_133_127_670)
internal val Res.string.compras_import_total: StringResource by lazy {
      StringResource("string:compras_import_total", "compras_import_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19316, 44),
      ))
    }

@delegate:ResourceContentHash(583_999_127)
internal val Res.string.compras_import_unsupported: StringResource by lazy {
      StringResource("string:compras_import_unsupported", "compras_import_unsupported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19361, 126),
      ))
    }

@delegate:ResourceContentHash(1_664_761_327)
internal val Res.string.compras_import_warning_middle: StringResource by lazy {
      StringResource("string:compras_import_warning_middle", "compras_import_warning_middle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19488, 61),
      ))
    }

@delegate:ResourceContentHash(1_566_641_141)
internal val Res.string.compras_import_warning_prefix: StringResource by lazy {
      StringResource("string:compras_import_warning_prefix", "compras_import_warning_prefix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19550, 105),
      ))
    }

@delegate:ResourceContentHash(632_219_696)
internal val Res.string.compras_import_warning_title: StringResource by lazy {
      StringResource("string:compras_import_warning_title", "compras_import_warning_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19656, 52),
      ))
    }

@delegate:ResourceContentHash(-1_609_369_987)
internal val Res.string.compras_items: StringResource by lazy {
      StringResource("string:compras_items", "compras_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19709, 37),
      ))
    }

@delegate:ResourceContentHash(-1_086_962_595)
internal val Res.string.compras_no_data: StringResource by lazy {
      StringResource("string:compras_no_data", "compras_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19747, 35),
      ))
    }

@delegate:ResourceContentHash(-1_962_847_712)
internal val Res.string.compras_no_results: StringResource by lazy {
      StringResource("string:compras_no_results", "compras_no_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19783, 62),
      ))
    }

@delegate:ResourceContentHash(2_147_476_953)
internal val Res.string.compras_open_panel: StringResource by lazy {
      StringResource("string:compras_open_panel", "compras_open_panel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19846, 62),
      ))
    }

@delegate:ResourceContentHash(-429_175_017)
internal val Res.string.compras_orders: StringResource by lazy {
      StringResource("string:compras_orders", "compras_orders", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19909, 38),
      ))
    }

@delegate:ResourceContentHash(2_039_383_626)
internal val Res.string.compras_panel_average_value: StringResource by lazy {
      StringResource("string:compras_panel_average_value", "compras_panel_average_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19948, 47),
      ))
    }

@delegate:ResourceContentHash(-1_302_806_287)
internal val Res.string.compras_panel_axis_average_price: StringResource by lazy {
      StringResource("string:compras_panel_axis_average_price", "compras_panel_axis_average_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19996, 64),
      ))
    }

@delegate:ResourceContentHash(-1_648_293_605)
internal val Res.string.compras_panel_axis_cost: StringResource by lazy {
      StringResource("string:compras_panel_axis_cost", "compras_panel_axis_cost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20061, 47),
      ))
    }

@delegate:ResourceContentHash(-874_838_795)
internal val Res.string.compras_panel_axis_orders: StringResource by lazy {
      StringResource("string:compras_panel_axis_orders", "compras_panel_axis_orders", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20109, 45),
      ))
    }

@delegate:ResourceContentHash(369_794_559)
internal val Res.string.compras_panel_axis_variation: StringResource by lazy {
      StringResource("string:compras_panel_axis_variation", "compras_panel_axis_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20218, 56),
      ))
    }

@delegate:ResourceContentHash(370_142_647)
internal val Res.string.compras_panel_axis_variation_value: StringResource by lazy {
      StringResource("string:compras_panel_axis_variation_value", "compras_panel_axis_variation_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20155, 62),
      ))
    }

@delegate:ResourceContentHash(-600_934_001)
internal val Res.string.compras_panel_categories_increase: StringResource by lazy {
      StringResource("string:compras_panel_categories_increase", "compras_panel_categories_increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20275, 73),
      ))
    }

@delegate:ResourceContentHash(-488_602_295)
internal val Res.string.compras_panel_categories_reduction: StringResource by lazy {
      StringResource("string:compras_panel_categories_reduction", "compras_panel_categories_reduction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20349, 74),
      ))
    }

@delegate:ResourceContentHash(-1_343_583_804)
internal val Res.string.compras_panel_category_evolution: StringResource by lazy {
      StringResource("string:compras_panel_category_evolution", "compras_panel_category_evolution", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20424, 88),
      ))
    }

@delegate:ResourceContentHash(1_757_535_485)
internal val Res.string.compras_panel_category_total: StringResource by lazy {
      StringResource("string:compras_panel_category_total", "compras_panel_category_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20589, 60),
      ))
    }

@delegate:ResourceContentHash(1_817_857_060)
internal val Res.string.compras_panel_category_total_in: StringResource by lazy {
      StringResource("string:compras_panel_category_total_in", "compras_panel_category_total_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20513, 75),
      ))
    }

@delegate:ResourceContentHash(870_209_342)
internal val Res.string.compras_panel_chart_annual_cost: StringResource by lazy {
      StringResource("string:compras_panel_chart_annual_cost", "compras_panel_chart_annual_cost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20650, 83),
      ))
    }

@delegate:ResourceContentHash(-692_748_362)
internal val Res.string.compras_panel_chart_budget_actual: StringResource by lazy {
      StringResource("string:compras_panel_chart_budget_actual", "compras_panel_chart_budget_actual", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20734, 73),
      ))
    }

@delegate:ResourceContentHash(468_171_838)
internal val Res.string.compras_panel_chart_categories: StringResource by lazy {
      StringResource("string:compras_panel_chart_categories", "compras_panel_chart_categories", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20808, 66),
      ))
    }

@delegate:ResourceContentHash(892_889_888)
internal val Res.string.compras_panel_chart_extras_evolution: StringResource by lazy {
      StringResource("string:compras_panel_chart_extras_evolution", "compras_panel_chart_extras_evolution", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20875, 84),
      ))
    }

@delegate:ResourceContentHash(280_349_597)
internal val Res.string.compras_panel_chart_top_increases: StringResource by lazy {
      StringResource("string:compras_panel_chart_top_increases", "compras_panel_chart_top_increases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20960, 61),
      ))
    }

@delegate:ResourceContentHash(877_169_967)
internal val Res.string.compras_panel_chart_top_reductions: StringResource by lazy {
      StringResource("string:compras_panel_chart_top_reductions", "compras_panel_chart_top_reductions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21022, 66),
      ))
    }

@delegate:ResourceContentHash(403_621_433)
internal val Res.string.compras_panel_col_average: StringResource by lazy {
      StringResource("string:compras_panel_col_average", "compras_panel_col_average", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21149, 41),
      ))
    }

@delegate:ResourceContentHash(-2_056_736_818)
internal val Res.string.compras_panel_col_average_price: StringResource by lazy {
      StringResource("string:compras_panel_col_average_price", "compras_panel_col_average_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21089, 59),
      ))
    }

@delegate:ResourceContentHash(-406_885_001)
internal val Res.string.compras_panel_col_category: StringResource by lazy {
      StringResource("string:compras_panel_col_category", "compras_panel_col_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21191, 58),
      ))
    }

@delegate:ResourceContentHash(166_336_023)
internal val Res.string.compras_panel_col_current_total: StringResource by lazy {
      StringResource("string:compras_panel_col_current_total", "compras_panel_col_current_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21250, 59),
      ))
    }

@delegate:ResourceContentHash(-1_171_484_782)
internal val Res.string.compras_panel_col_increase: StringResource by lazy {
      StringResource("string:compras_panel_col_increase", "compras_panel_col_increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21310, 46),
      ))
    }

@delegate:ResourceContentHash(-375_296_791)
internal val Res.string.compras_panel_col_month_value: StringResource by lazy {
      StringResource("string:compras_panel_col_month_value", "compras_panel_col_month_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21357, 45),
      ))
    }

@delegate:ResourceContentHash(-1_179_543_529)
internal val Res.string.compras_panel_col_previous_total: StringResource by lazy {
      StringResource("string:compras_panel_col_previous_total", "compras_panel_col_previous_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21403, 64),
      ))
    }

@delegate:ResourceContentHash(-1_833_649_390)
internal val Res.string.compras_panel_col_reduction: StringResource by lazy {
      StringResource("string:compras_panel_col_reduction", "compras_panel_col_reduction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21468, 47),
      ))
    }

@delegate:ResourceContentHash(-1_703_224_615)
internal val Res.string.compras_panel_col_total_value: StringResource by lazy {
      StringResource("string:compras_panel_col_total_value", "compras_panel_col_total_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21516, 53),
      ))
    }

@delegate:ResourceContentHash(-1_620_666_033)
internal val Res.string.compras_panel_col_unit_price: StringResource by lazy {
      StringResource("string:compras_panel_col_unit_price", "compras_panel_col_unit_price", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21570, 60),
      ))
    }

@delegate:ResourceContentHash(369_794_559)
internal val Res.string.compras_panel_col_variation_percent: StringResource by lazy {
      StringResource("string:compras_panel_col_variation_percent", "compras_panel_col_variation_percent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21631, 63),
      ))
    }

@delegate:ResourceContentHash(370_142_647)
internal val Res.string.compras_panel_col_variation_value: StringResource by lazy {
      StringResource("string:compras_panel_col_variation_value", "compras_panel_col_variation_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21695, 61),
      ))
    }

@delegate:ResourceContentHash(-992_615_377)
internal val Res.string.compras_panel_detailed_results: StringResource by lazy {
      StringResource("string:compras_panel_detailed_results", "compras_panel_detailed_results", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21757, 66),
      ))
    }

@delegate:ResourceContentHash(8_582_189)
internal val Res.string.compras_panel_economy: StringResource by lazy {
      StringResource("string:compras_panel_economy", "compras_panel_economy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21824, 77),
      ))
    }

@delegate:ResourceContentHash(1_865_762_455)
internal val Res.string.compras_panel_empty: StringResource by lazy {
      StringResource("string:compras_panel_empty", "compras_panel_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21902, 99),
      ))
    }

@delegate:ResourceContentHash(1_378_949_085)
internal val Res.string.compras_panel_extras_by_directorate: StringResource by lazy {
      StringResource("string:compras_panel_extras_by_directorate", "compras_panel_extras_by_directorate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22002, 71),
      ))
    }

@delegate:ResourceContentHash(747_749_642)
internal val Res.string.compras_panel_extras_directorate: StringResource by lazy {
      StringResource("string:compras_panel_extras_directorate", "compras_panel_extras_directorate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22074, 52),
      ))
    }

@delegate:ResourceContentHash(1_962_311_789)
internal val Res.string.compras_panel_extras_legend: StringResource by lazy {
      StringResource("string:compras_panel_extras_legend", "compras_panel_extras_legend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22127, 63),
      ))
    }

@delegate:ResourceContentHash(-1_086_962_595)
internal val Res.string.compras_panel_extras_no_data: StringResource by lazy {
      StringResource("string:compras_panel_extras_no_data", "compras_panel_extras_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22191, 48),
      ))
    }

@delegate:ResourceContentHash(-1_441_960_694)
internal val Res.string.compras_panel_extras_no_directorate: StringResource by lazy {
      StringResource("string:compras_panel_extras_no_directorate", "compras_panel_extras_no_directorate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22240, 63),
      ))
    }

@delegate:ResourceContentHash(-34_326_690)
internal val Res.string.compras_panel_extras_previous: StringResource by lazy {
      StringResource("string:compras_panel_extras_previous", "compras_panel_extras_previous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22304, 77),
      ))
    }

@delegate:ResourceContentHash(2_125_499_197)
internal val Res.string.compras_panel_extras_reasons: StringResource by lazy {
      StringResource("string:compras_panel_extras_reasons", "compras_panel_extras_reasons", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22382, 88),
      ))
    }

@delegate:ResourceContentHash(1_006_797_021)
internal val Res.string.compras_panel_extras_share_column: StringResource by lazy {
      StringResource("string:compras_panel_extras_share_column", "compras_panel_extras_share_column", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22471, 57),
      ))
    }

@delegate:ResourceContentHash(1_654_312_869)
internal val Res.string.compras_panel_extras_top_directorate: StringResource by lazy {
      StringResource("string:compras_panel_extras_top_directorate", "compras_panel_extras_top_directorate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22529, 80),
      ))
    }

@delegate:ResourceContentHash(-445_698_538)
internal val Res.string.compras_panel_extras_top_period: StringResource by lazy {
      StringResource("string:compras_panel_extras_top_period", "compras_panel_extras_top_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22610, 75),
      ))
    }

@delegate:ResourceContentHash(857_693_244)
internal val Res.string.compras_panel_extras_total: StringResource by lazy {
      StringResource("string:compras_panel_extras_total", "compras_panel_extras_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22736, 58),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.compras_panel_extras_total_column: StringResource by lazy {
      StringResource("string:compras_panel_extras_total_column", "compras_panel_extras_total_column", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22686, 49),
      ))
    }

@delegate:ResourceContentHash(-166_614_770)
internal val Res.string.compras_panel_extras_variation: StringResource by lazy {
      StringResource("string:compras_panel_extras_variation", "compras_panel_extras_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22795, 94),
      ))
    }

@delegate:ResourceContentHash(33_445_184)
internal val Res.string.compras_panel_increase_month: StringResource by lazy {
      StringResource("string:compras_panel_increase_month", "compras_panel_increase_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22890, 96),
      ))
    }

@delegate:ResourceContentHash(-107_391_860)
internal val Res.string.compras_panel_increase_period: StringResource by lazy {
      StringResource("string:compras_panel_increase_period", "compras_panel_increase_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22987, 101),
      ))
    }

@delegate:ResourceContentHash(-561_060_027)
internal val Res.string.compras_panel_largest_increase: StringResource by lazy {
      StringResource("string:compras_panel_largest_increase", "compras_panel_largest_increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23089, 74),
      ))
    }

@delegate:ResourceContentHash(-448_728_321)
internal val Res.string.compras_panel_largest_reduction: StringResource by lazy {
      StringResource("string:compras_panel_largest_reduction", "compras_panel_largest_reduction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23164, 75),
      ))
    }

@delegate:ResourceContentHash(-1_444_083_509)
internal val Res.string.compras_panel_month_highest_spend: StringResource by lazy {
      StringResource("string:compras_panel_month_highest_spend", "compras_panel_month_highest_spend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23240, 69),
      ))
    }

@delegate:ResourceContentHash(1_044_113_322)
internal val Res.string.compras_panel_month_highest_variation: StringResource by lazy {
      StringResource("string:compras_panel_month_highest_variation", "compras_panel_month_highest_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23310, 81),
      ))
    }

@delegate:ResourceContentHash(81_302_913)
internal val Res.string.compras_panel_month_lowest_spend: StringResource by lazy {
      StringResource("string:compras_panel_month_lowest_spend", "compras_panel_month_lowest_spend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23392, 68),
      ))
    }

@delegate:ResourceContentHash(-443_261_665)
internal val Res.string.compras_panel_month_lowest_variation: StringResource by lazy {
      StringResource("string:compras_panel_month_lowest_variation", "compras_panel_month_lowest_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23461, 80),
      ))
    }

@delegate:ResourceContentHash(-1_884_045_563)
internal val Res.string.compras_panel_month_total: StringResource by lazy {
      StringResource("string:compras_panel_month_total", "compras_panel_month_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23542, 49),
      ))
    }

@delegate:ResourceContentHash(-1_150_867_497)
internal val Res.string.compras_panel_monthly_average: StringResource by lazy {
      StringResource("string:compras_panel_monthly_average", "compras_panel_monthly_average", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23592, 57),
      ))
    }

@delegate:ResourceContentHash(-1_852_723_193)
internal val Res.string.compras_panel_months_with_savings: StringResource by lazy {
      StringResource("string:compras_panel_months_with_savings", "compras_panel_months_with_savings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23650, 65),
      ))
    }

@delegate:ResourceContentHash(491_411_008)
internal val Res.string.compras_panel_no_base: StringResource by lazy {
      StringResource("string:compras_panel_no_base", "compras_panel_no_base", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23716, 41),
      ))
    }

@delegate:ResourceContentHash(-1_864_051_043)
internal val Res.string.compras_panel_no_category_increases: StringResource by lazy {
      StringResource("string:compras_panel_no_category_increases", "compras_panel_no_category_increases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23758, 103),
      ))
    }

@delegate:ResourceContentHash(371_137_393)
internal val Res.string.compras_panel_no_category_reductions: StringResource by lazy {
      StringResource("string:compras_panel_no_category_reductions", "compras_panel_no_category_reductions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23862, 108),
      ))
    }

@delegate:ResourceContentHash(-1_086_962_595)
internal val Res.string.compras_panel_no_data: StringResource by lazy {
      StringResource("string:compras_panel_no_data", "compras_panel_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23971, 41),
      ))
    }

@delegate:ResourceContentHash(-1_758_545_949)
internal val Res.string.compras_panel_no_increase: StringResource by lazy {
      StringResource("string:compras_panel_no_increase", "compras_panel_no_increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24013, 69),
      ))
    }

@delegate:ResourceContentHash(979_871_280)
internal val Res.string.compras_panel_no_reduction: StringResource by lazy {
      StringResource("string:compras_panel_no_reduction", "compras_panel_no_reduction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24083, 74),
      ))
    }

@delegate:ResourceContentHash(-2_002_163_182)
internal val Res.string.compras_panel_no_variation: StringResource by lazy {
      StringResource("string:compras_panel_no_variation", "compras_panel_no_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24158, 66),
      ))
    }

@delegate:ResourceContentHash(-1_157_526_807)
internal val Res.string.compras_panel_overview: StringResource by lazy {
      StringResource("string:compras_panel_overview", "compras_panel_overview", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24225, 46),
      ))
    }

@delegate:ResourceContentHash(-687_030_632)
internal val Res.string.compras_panel_period_custom: StringResource by lazy {
      StringResource("string:compras_panel_period_custom", "compras_panel_period_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24272, 55),
      ))
    }

@delegate:ResourceContentHash(-1_451_219_714)
internal val Res.string.compras_panel_period_month: StringResource by lazy {
      StringResource("string:compras_panel_period_month", "compras_panel_period_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24328, 42),
      ))
    }

@delegate:ResourceContentHash(902_461_574)
internal val Res.string.compras_panel_period_year: StringResource by lazy {
      StringResource("string:compras_panel_period_year", "compras_panel_period_year", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24371, 41),
      ))
    }

@delegate:ResourceContentHash(-1_883_002_734)
internal val Res.string.compras_panel_planned_total: StringResource by lazy {
      StringResource("string:compras_panel_planned_total", "compras_panel_planned_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24413, 55),
      ))
    }

@delegate:ResourceContentHash(-613_119_495)
internal val Res.string.compras_panel_previous_total: StringResource by lazy {
      StringResource("string:compras_panel_previous_total", "compras_panel_previous_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24469, 72),
      ))
    }

@delegate:ResourceContentHash(1_114_770_570)
internal val Res.string.compras_panel_provisioned: StringResource by lazy {
      StringResource("string:compras_panel_provisioned", "compras_panel_provisioned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24542, 49),
      ))
    }

@delegate:ResourceContentHash(1_800_460_347)
internal val Res.string.compras_panel_realized: StringResource by lazy {
      StringResource("string:compras_panel_realized", "compras_panel_realized", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24649, 42),
      ))
    }

@delegate:ResourceContentHash(-2_146_200_989)
internal val Res.string.compras_panel_realized_total: StringResource by lazy {
      StringResource("string:compras_panel_realized_total", "compras_panel_realized_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24592, 56),
      ))
    }

@delegate:ResourceContentHash(-1_075_724_839)
internal val Res.string.compras_panel_reduction_month: StringResource by lazy {
      StringResource("string:compras_panel_reduction_month", "compras_panel_reduction_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24692, 97),
      ))
    }

@delegate:ResourceContentHash(385_447_282)
internal val Res.string.compras_panel_reduction_period: StringResource by lazy {
      StringResource("string:compras_panel_reduction_period", "compras_panel_reduction_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24790, 106),
      ))
    }

@delegate:ResourceContentHash(39_651_131)
internal val Res.string.compras_panel_savings_value: StringResource by lazy {
      StringResource("string:compras_panel_savings_value", "compras_panel_savings_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24897, 51),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("compras_import_action", Res.string.compras_import_action)
  map.put("compras_import_category_label", Res.string.compras_import_category_label)
  map.put("compras_import_error", Res.string.compras_import_error)
  map.put("compras_import_format", Res.string.compras_import_format)
  map.put("compras_import_invalid_file", Res.string.compras_import_invalid_file)
  map.put("compras_import_items", Res.string.compras_import_items)
  map.put("compras_import_period", Res.string.compras_import_period)
  map.put("compras_import_processing", Res.string.compras_import_processing)
  map.put("compras_import_ready", Res.string.compras_import_ready)
  map.put("compras_import_remove_file", Res.string.compras_import_remove_file)
  map.put("compras_import_select_file", Res.string.compras_import_select_file)
  map.put("compras_import_sheet", Res.string.compras_import_sheet)
  map.put("compras_import_step_category", Res.string.compras_import_step_category)
  map.put("compras_import_step_upload", Res.string.compras_import_step_upload)
  map.put("compras_import_success", Res.string.compras_import_success)
  map.put("compras_import_total", Res.string.compras_import_total)
  map.put("compras_import_unsupported", Res.string.compras_import_unsupported)
  map.put("compras_import_warning_middle", Res.string.compras_import_warning_middle)
  map.put("compras_import_warning_prefix", Res.string.compras_import_warning_prefix)
  map.put("compras_import_warning_title", Res.string.compras_import_warning_title)
  map.put("compras_items", Res.string.compras_items)
  map.put("compras_no_data", Res.string.compras_no_data)
  map.put("compras_no_results", Res.string.compras_no_results)
  map.put("compras_open_panel", Res.string.compras_open_panel)
  map.put("compras_orders", Res.string.compras_orders)
  map.put("compras_panel_average_value", Res.string.compras_panel_average_value)
  map.put("compras_panel_axis_average_price", Res.string.compras_panel_axis_average_price)
  map.put("compras_panel_axis_cost", Res.string.compras_panel_axis_cost)
  map.put("compras_panel_axis_orders", Res.string.compras_panel_axis_orders)
  map.put("compras_panel_axis_variation", Res.string.compras_panel_axis_variation)
  map.put("compras_panel_axis_variation_value", Res.string.compras_panel_axis_variation_value)
  map.put("compras_panel_categories_increase", Res.string.compras_panel_categories_increase)
  map.put("compras_panel_categories_reduction", Res.string.compras_panel_categories_reduction)
  map.put("compras_panel_category_evolution", Res.string.compras_panel_category_evolution)
  map.put("compras_panel_category_total", Res.string.compras_panel_category_total)
  map.put("compras_panel_category_total_in", Res.string.compras_panel_category_total_in)
  map.put("compras_panel_chart_annual_cost", Res.string.compras_panel_chart_annual_cost)
  map.put("compras_panel_chart_budget_actual", Res.string.compras_panel_chart_budget_actual)
  map.put("compras_panel_chart_categories", Res.string.compras_panel_chart_categories)
  map.put("compras_panel_chart_extras_evolution", Res.string.compras_panel_chart_extras_evolution)
  map.put("compras_panel_chart_top_increases", Res.string.compras_panel_chart_top_increases)
  map.put("compras_panel_chart_top_reductions", Res.string.compras_panel_chart_top_reductions)
  map.put("compras_panel_col_average", Res.string.compras_panel_col_average)
  map.put("compras_panel_col_average_price", Res.string.compras_panel_col_average_price)
  map.put("compras_panel_col_category", Res.string.compras_panel_col_category)
  map.put("compras_panel_col_current_total", Res.string.compras_panel_col_current_total)
  map.put("compras_panel_col_increase", Res.string.compras_panel_col_increase)
  map.put("compras_panel_col_month_value", Res.string.compras_panel_col_month_value)
  map.put("compras_panel_col_previous_total", Res.string.compras_panel_col_previous_total)
  map.put("compras_panel_col_reduction", Res.string.compras_panel_col_reduction)
  map.put("compras_panel_col_total_value", Res.string.compras_panel_col_total_value)
  map.put("compras_panel_col_unit_price", Res.string.compras_panel_col_unit_price)
  map.put("compras_panel_col_variation_percent", Res.string.compras_panel_col_variation_percent)
  map.put("compras_panel_col_variation_value", Res.string.compras_panel_col_variation_value)
  map.put("compras_panel_detailed_results", Res.string.compras_panel_detailed_results)
  map.put("compras_panel_economy", Res.string.compras_panel_economy)
  map.put("compras_panel_empty", Res.string.compras_panel_empty)
  map.put("compras_panel_extras_by_directorate", Res.string.compras_panel_extras_by_directorate)
  map.put("compras_panel_extras_directorate", Res.string.compras_panel_extras_directorate)
  map.put("compras_panel_extras_legend", Res.string.compras_panel_extras_legend)
  map.put("compras_panel_extras_no_data", Res.string.compras_panel_extras_no_data)
  map.put("compras_panel_extras_no_directorate", Res.string.compras_panel_extras_no_directorate)
  map.put("compras_panel_extras_previous", Res.string.compras_panel_extras_previous)
  map.put("compras_panel_extras_reasons", Res.string.compras_panel_extras_reasons)
  map.put("compras_panel_extras_share_column", Res.string.compras_panel_extras_share_column)
  map.put("compras_panel_extras_top_directorate", Res.string.compras_panel_extras_top_directorate)
  map.put("compras_panel_extras_top_period", Res.string.compras_panel_extras_top_period)
  map.put("compras_panel_extras_total", Res.string.compras_panel_extras_total)
  map.put("compras_panel_extras_total_column", Res.string.compras_panel_extras_total_column)
  map.put("compras_panel_extras_variation", Res.string.compras_panel_extras_variation)
  map.put("compras_panel_increase_month", Res.string.compras_panel_increase_month)
  map.put("compras_panel_increase_period", Res.string.compras_panel_increase_period)
  map.put("compras_panel_largest_increase", Res.string.compras_panel_largest_increase)
  map.put("compras_panel_largest_reduction", Res.string.compras_panel_largest_reduction)
  map.put("compras_panel_month_highest_spend", Res.string.compras_panel_month_highest_spend)
  map.put("compras_panel_month_highest_variation", Res.string.compras_panel_month_highest_variation)
  map.put("compras_panel_month_lowest_spend", Res.string.compras_panel_month_lowest_spend)
  map.put("compras_panel_month_lowest_variation", Res.string.compras_panel_month_lowest_variation)
  map.put("compras_panel_month_total", Res.string.compras_panel_month_total)
  map.put("compras_panel_monthly_average", Res.string.compras_panel_monthly_average)
  map.put("compras_panel_months_with_savings", Res.string.compras_panel_months_with_savings)
  map.put("compras_panel_no_base", Res.string.compras_panel_no_base)
  map.put("compras_panel_no_category_increases", Res.string.compras_panel_no_category_increases)
  map.put("compras_panel_no_category_reductions", Res.string.compras_panel_no_category_reductions)
  map.put("compras_panel_no_data", Res.string.compras_panel_no_data)
  map.put("compras_panel_no_increase", Res.string.compras_panel_no_increase)
  map.put("compras_panel_no_reduction", Res.string.compras_panel_no_reduction)
  map.put("compras_panel_no_variation", Res.string.compras_panel_no_variation)
  map.put("compras_panel_overview", Res.string.compras_panel_overview)
  map.put("compras_panel_period_custom", Res.string.compras_panel_period_custom)
  map.put("compras_panel_period_month", Res.string.compras_panel_period_month)
  map.put("compras_panel_period_year", Res.string.compras_panel_period_year)
  map.put("compras_panel_planned_total", Res.string.compras_panel_planned_total)
  map.put("compras_panel_previous_total", Res.string.compras_panel_previous_total)
  map.put("compras_panel_provisioned", Res.string.compras_panel_provisioned)
  map.put("compras_panel_realized", Res.string.compras_panel_realized)
  map.put("compras_panel_realized_total", Res.string.compras_panel_realized_total)
  map.put("compras_panel_reduction_month", Res.string.compras_panel_reduction_month)
  map.put("compras_panel_reduction_period", Res.string.compras_panel_reduction_period)
  map.put("compras_panel_savings_value", Res.string.compras_panel_savings_value)
}
